module.exports = {
  "country": "CZ",
  "artist": "Vesna",
  "song": "My Sisters Crown",
  "year": "2023",
  "place": "10",
  "spotify": "59md7R7fW5LjSbZITzzn3n"
};